import React from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

interface Props {
  title?: string;
  sx?: SxProps;
}

const CroppableItem: React.FC<Props> = ({ title, sx, children }) => (
  <Box
    title={title}
    sx={{
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default CroppableItem;
